<template>
    <el-row class="warp">
      <el-tag type="success" size="20">任务提醒列表</el-tag>
      <el-col
        :span="24"
        class="warp-main"
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <!--列表-->
        <el-table
          :data="tasks"
          highlight-current-row
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="80">
          </el-table-column>
          <el-table-column prop="name" label="提醒标题">
            <template slot-scope="scope">
              <el-tag type="success"
                disable-transitions
                >{{ scope.row.name }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="begintime"
            :formatter="formatBegin"
            label="开始时间"
          >
          </el-table-column>
          <el-table-column prop="endtime" :formatter="formatEnd" label="结束时间">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="removeUser(scope.$index, scope.row)"
                >不再提醒</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="10"
            :total="total"
            style="float: right"
          >
          </el-pagination>
        </el-col>
      </el-col>
    </el-row>
  </template>
  
  <script>
  import API from "../../api/frbasicapi/taskmanager";
  
  export default {
    data() {
      return {
        filters: {
          name: "",
        },
  
        loading: false,
        tasks: [],
        total: 0,
        page: 1,
        limit: 10,
      };
    },
    methods: {
      formatBegin: function (row, column) {
        return this.dateFormatString(row.begintime);
      },
      formatEnd: function (row, column) {
        return this.dateFormatString(row.endtime);
      },
      handleCurrentChange(val) {
        this.page = val;
        this.search();
      },
      handleSizeChange(val) {
        this.limit = val;
        this.search();
      },
      handleSearch() {
        this.total = 0;
        this.page = 1;
        this.search();
      },
  
      //获取用户列表
      search: function () {
        let that = this;
        let params = {
          pageNum: that.page,
          pageSize: 10,
          //name: that.filters.name,
        };
  
        that.loading = true;
        API.list(params)
          .then(
            function (result) {
              that.loading = false;
              if (result && result.data.totalSize) {
                that.total = result.data.totalSize;
                that.tasks = result.data.content;
                if (result.data.totalSize > 0) {
                  that.open2(
                    "<strong>您有<a href='#/index'>" +
                      result.data.totalSize +
                      "</a>条任务待处理哟</strong>"
                  );
                }
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000,
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000,
            });
          });
      },
  
      dateFormatString(data) {
        var date = new Date(data);
        var month = date.getMonth() + 1;
        const time =
          date.getFullYear() +
          "-" +
          this.dateChange(month) +
          "-" +
          this.dateChange(date.getDate()) +
          " " +
          this.dateChange(date.getHours()) +
          ":" +
          this.dateChange(date.getMinutes()) +
          ":" +
          this.dateChange(date.getSeconds());
        return time;
      },
  
      dateChange(m) {
        return m < 10 ? "0" + m : m;
      },
      removeUser: function (index, row) {
        let that = this;
        this.$confirm("确认不再提醒吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            API.change({ id: row.id })
              .then(
                function (result) {
                  that.loading = false;
                  if (result && parseInt(result.code) === 0) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500,
                    });
                    that.search();
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
              });
          })
          .catch(() => {});
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$nextTick(() => {});
      },
  
      open2(msg) {
        this.$notify({
          title: "任务提醒",
          dangerouslyUseHTMLString: true,
          //message: '<strong>这是 <i>HTML</i> 片段</strong>'
          message: msg,
          duration: 0,
        });
      },
    },
  
    mounted() {
      this.handleSearch();
    },
  };
  </script>
  
  <style scoped>
  </style>
  